export default __webpack_public_path__ + "static/media/ic-exclamation.ae2d5aca.svg";